module.exports = __webpack_public_path__ + "img/qgjj-01.prt.dff2d5c8.jpg";